import InvoicesContent from '..';
import InvoicesMultipointContent from "./InvoicesMultipointContent";

import { Tabs, Tab, Box } from '@mui/material';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';

import GasIcon from '../../../assets/GasIcon';
import LightIcon from '../../../assets/LightIcon';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useSettingsContext } from '@/components/Settings/hooks/useSettingsContext';
import { useSearchParams } from 'react-router-dom';

const InvoicesTabs = () => {
  const Settings = useSettingsContext();
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [invoiceType, setInvoiceType] = useState(
      searchParams.get("contractType") ?? Settings.features.displayTypes[0]
    ); // 'electricity', 'gas',  'multipoint'

  const handleChangeInvoiceType = (event, value) => {
    searchParams.set("contractType", value);
    if (searchParams.get("contractName")) {
      searchParams.delete("contractName");
    }
    setSearchParams(searchParams);
    setInvoiceType(value);
  };

  function showTab(type) {
    return Settings?.features?.displayTypes.includes(type)
  }

  return <Box sx={{ width: '100%', marginTop: -2 }}>
    {Settings?.features?.displayTypes.length > 1 ? <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>
        <Tabs value={invoiceType} onChange={handleChangeInvoiceType}>
          {showTab('multipoint') && <Tab label={t("common:text.contracts_tab_title_multipoint")} value="multipoint" icon={<DeviceHubIcon />}/>}

          {showTab('electricity') &&
           <Tab label={t("common:text.contracts_tab_title_electricty")} value="electricity" icon={<LightIcon />}/>
          }
          {showTab('gas') &&
            <Tab label={t("common:text.contracts_tab_title_gas")} value="gas" icon={<GasIcon />}/>
          }
        </Tabs>
      </Box>
      <Box sx={{mt: 2}}>
        {showTab('multipoint') && <div hidden={invoiceType !== 'multipoint'}><InvoicesMultipointContent/></div>}
        {showTab('electricity') && <div hidden={invoiceType !== 'electricity'}><InvoicesContent type="electricity"/></div>}
        {showTab('gas') && <div hidden={invoiceType !== 'gas'}><InvoicesContent type="gas"/></div>}
      </Box>
    </> : <>
      {showTab('multipoint') && <InvoicesMultipointContent/>}
      {showTab('electricity') && <InvoicesContent type="electricity" />}
      {showTab('gas') && <InvoicesContent type="gas" />}
    </>}
  </Box>;

}

export default InvoicesTabs;
